import { ConvertedRealEstate } from '../../../../../../@types/real-estate-api-types'
import { useTranslation } from 'react-i18next'
import { Button, Modal } from 'is24-corecss'
import { ContentStateInterface } from '../../../../../../@types/types'
import React, { MouseEvent, useCallback, useState } from 'react'
import { useOpenWizardWithCurrentDataCallback } from './ObjectChooserItemsHooks'
import { IconS24ChevronRight24 } from '@is24/cosma-ui-icons'
import { ObjectsContainer } from '../objectChooserModal/objectChooserModalContent/objectsContainer/ObjectsContainer'
import styles from './ObjectChooserItem.module.css'
import { ClfRealEstateCard } from '../clfRealEstateCard/ClfRealEstateCard'
import { tracking } from '../../../../../../tracking/tracking'
import { InitState } from '../../../../../../redux/reducers/root/initialState'
import { useAppSelector } from '../../../../../../app/hooks'

export function ObjectChooserItem(props: { objects: ConvertedRealEstate[] }) {
  const { t } = useTranslation()
  const flow = useAppSelector((state: InitState) => state.flowFeature.flow)
  const { objects } = props

  const [visible, setVisible] = useState(false)
  const singleObject = objects.length === 1

  const object = objects[0]
  const listing = object.listing

  const goNext = useOpenWizardWithCurrentDataCallback(object, true)
  const closeModal = useCallback((e?: MouseEvent<unknown>) => {
    e?.stopPropagation()
    setVisible(false)
  }, [])

  const onCardClicked = useCallback(() => {
    if (singleObject) {
      tracking({
        eventName: 'object_card_click',
        eventParameter: 'open_insertion_flow',
        flowInformation: flow?.flowInformation,
        entryMode: 'create',
        experiment: 'object_chooser',
      })
      goNext()
      return
    }
    tracking({
      eventName: 'object_card_click',
      eventParameter: 'object_card_click',
      flowInformation: flow?.flowInformation,
      entryMode: 'create',
      experiment: 'object_chooser',
    })
    setVisible(true)
  }, [singleObject, goNext, flow?.flowInformation])

  return (
    <>
      <ClfRealEstateCard
        onClick={onCardClicked}
        src={object.meta.mapImages?.fullSizeUrl}
        headline={`${listing.street} ${listing.houseNumber}`}
        address={`${listing.postcode} ${listing.city}`}
        className={`cursor-pointer ${styles.card}`}
        data-testid={`object-${object.meta.buildingId}`}
      >
        {singleObject ? (
          <UnitDetails category={object.category} listing={listing} />
        ) : (
          <>
            <Button appearance='text'>
              <span className='font-default-color'>Immobilie mit Einheiten </span>
            </Button>
            <IconS24ChevronRight24 className='button-icon-margin-left font-default-color' inline />
          </>
        )}
      </ClfRealEstateCard>
      {singleObject ? undefined : (
        <Modal visible={visible} onClose={closeModal} title={t('objectChooser.modal.title')}>
          <ObjectsContainer objects={objects} closeModal={closeModal} />
        </Modal>
      )}
    </>
  )
}

function UnitDetails(props: { category: string; listing: ContentStateInterface }) {
  const { t } = useTranslation()
  const { category, listing } = props

  const categoryLabelKey = () => {
    if (listing.buildingType && listing.buildingType.value === 'MULTI_FAMILY_HOUSE') {
      return t(`objectChooser.type.MULTIFAMILY_HOUSE`)
    } else {
      return t(`objectChooser.type.${category}`)
    }
  }

  return (
    <p className='font-lightgray'>
      <span className='font-body-medium-bold'>{categoryLabelKey()}</span>
      {listing.livingSpace && (
        <>
          <Separator /> {listing.livingSpace}m<sup>2</sup>
        </>
      )}
      {listing.room && (
        <>
          <Separator /> {`${listing.room} ${t('objectChooser.abbreviation.room')}`}
        </>
      )}
      {listing.floor && (
        <>
          <Separator /> {`${listing.floor}. ${t('objectChooser.abbreviation.floor')}`}
        </>
      )}
    </p>
  )
}

const Separator = () => {
  return <span className='margin-horizontal-s'>|</span>
}
